'use client'

import { useAIState, useUIState } from 'ai/rsc'
import { HiOutlinePencilSquare } from 'react-icons/hi2'

export function ClearButton({
  className = 'text-3xl  rounded-full p-2',
  title
}: {
  className?: string
  title?: string
}) {
  const [messagesUIState, setMessagesUIState] = useUIState()
  const [aiState, setAIState] = useAIState()

  return (
    <button
      className={className}
      onClick={() => {
        setMessagesUIState([])
        setAIState({ messages: [], chatId: '' })
      }}
    >
      <HiOutlinePencilSquare />
      {title}
    </button>
  )
}
